import {
  REACT_APP_TIMELINE_API_URL,
  REACT_APP_TIMELINE_API_KEY,
} from 'src/utils/constants';

/**
 * @returns {string|null} 
 */
export const getUserIdFromLocalStorage = () => {
  try {
    const userData = localStorage.getItem('user');
    if (!userData) {
      console.warn('No se encontró información de usuario en localStorage');
      return null;
    }

    const user = JSON.parse(userData);
    
    if (!user.username) {
      console.warn('El objeto user no contiene username');
      return null;
    }

    return user.username;
  } catch (error) {
    console.error('Error al obtener userId del localStorage:', error);
    return null;
  }
};

/**
 * @param {string} investorCoreCapitalId 
 * @param {number} limit 
 * @param {number} page -
 * @returns {Promise<any>} 
 */
export const getInvestorDocuments = async (investorCoreCapitalId, limit =100, page = 1,UserToken) => {
  try {
    const finalUserId = getUserIdFromLocalStorage();
    if (!finalUserId) {
      throw new Error('No se pudo obtener el ID del usuario. Verifique que esté logueado correctamente.');
    }
    const url = `${REACT_APP_TIMELINE_API_URL}/muniments/${finalUserId}?limit=${limit}&page=${page}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': REACT_APP_TIMELINE_API_KEY,
        'x-token': UserToken,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    return data;
  } catch (error) {
    console.error('Error al obtener documentos del inversor:', error);
    throw error;
  }
};

